import * as Yup from 'yup';

export const claimDataSchema = Yup.object().shape({
    descriptionOfEvent: Yup.string().required('Required'),
});
